export function requiresAuthHook ($log, $transitions, authConfig, AuthService) {
  'ngInject'

  // Check if requiresAuth is truthy
  const requiresAuthCriteria = {
    to: state => state.data && state.data.requiresAuth
  }

  // Check that user is authenticated, and redirect to login otherwise
  const redirectToLogin = transition => {
    const $state = transition.router.stateService

    // Short-circuit: skip server round-trip when already authenticated locally
    if (AuthService.isAuthenticated) {
      return null
    }

    return AuthService.ensureAuthenticated({ skipRedirect: true })
      .then(isAuthed => {
        if (!isAuthed) {
          $log.warn(`Auth required for transitioning to state: '${transition.to().name}'. Redirecting to login.`)
          return $state.target(authConfig.notAuthenticatedState)
        }

        return null
      })
  }

  $transitions.onBefore(requiresAuthCriteria, redirectToLogin, { priority: 10 })
}
